import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-payment-gateway',
  templateUrl: './payment-gateway.component.html',
  styleUrls: ['./payment-gateway.component.css'],
})
export class PaymentGatewayComponent implements OnInit {
  iframeUrl: SafeResourceUrl | undefined;
  isLoading: boolean = true; // To control the loader visibility

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const sessionUrl = sessionStorage.getItem('url'); // Fetch `url` from sessionStorage
    const currentUrl = window.location.href; // Get the current browser URL
    const parsedCurrentUrl = new URL(currentUrl); // Parse the current URL to extract params
    const eurl = parsedCurrentUrl.searchParams.get('eurl'); // Fetch `eurl` from URL params

    if (eurl) {
      // If `eurl` exists in the current URL, decode and use it
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(decodeURIComponent(eurl));
    } else if (sessionUrl) {
      // If `eurl` doesn't exist, fallback to `sessionUrl`
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(sessionUrl);
    } else {
      // Handle the case where neither `eurl` nor `sessionUrl` is available
      console.error('No valid URL or eurl found.');
    }
  }

  onIframeLoad(): void {
    // Hide the loader once the iframe is loaded
    this.isLoading = false;
  }
}